<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Listado de ventas</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Ventas</a></li>
        <li class="breadcrumb-item active">Listado de ventas</li>
      </ol>
    </div>
    <div class="card">
      <generic-header
        :textButton="'Nueva venta'"
        :url="'/admin/venta/nuevo'"
        :isButton="false"
        :status="status"
        :isReadOnly="false"
        :typeFields="typeFields"
        @change-filter="changeFilter"
      />
      <!-- <div class="card-header">
                <button type="button" class="btn btn-theme">Nueva venta</button>
            </div> -->
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Vendedor</th>
              <th>Cliente</th>
              <th>Total</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="sale in sales" :key="sale.id">
              <td>{{ sale.document }}</td>
              <td>{{ sale.sellerName }}</td>
              <td>{{ sale.nameReference }}</td>
              <td>{{ mymoney(sale.total) }}</td>
              <td>
                <span class="btn btn-danger btn-sm" v-if="sale.state === 0"
                  >Anulado</span
                >
                <span class="btn btn-warning btn-sm" v-if="sale.state === 2"
                  >Pendiente</span
                >
                <span class="btn btn-success btn-sm" v-if="sale.state === 1"
                  >Pagado</span
                >
              </td>
              <td>{{ convertDate(sale.sale_date) }}</td>
              <td>
                <template>
                  <div>
                    <template v-if="sale.state != 0">
                      <button
                        v-tooltip.top-center="'Anular venta'"
                        class="btn btn-danger"
                      >
                        <i
                          class="icon-fa icon-fa-trash"
                          @click="openModal(sale.id)"
                        />
                      </button>
                    </template>
                    <router-link
                      v-if="sale.state === 2"
                      v-tooltip.top-center="'Cobrar venta'"
                      class="btn btn-warning"
                      :to="`/admin/venta/cobrar?id=${sale.id}`"
                    >
                      <i class="icon-fa icon-fa-shopping-cart"
                    /></router-link>
                    <router-link
                      v-tooltip.top-center="'Ver venta'"
                      class="btn btn-success"
                      :to="`/admin/venta/ver?id=${sale.id}`"
                    >
                      <i class="icon-fa icon-fa-eye"
                    /></router-link>
                    <router-link
                      v-tooltip.top-center="'Imprimir'"
                      class="btn btn-primary"
                      :to="`/admin/venta/imprimir?id=${sale.id}`"
                    >
                      <i class="icon-fa icon-fa-print"
                    /></router-link>
                    <!-- <print 
                                            :isShow="sale.state===1?true:false" 
                                            :isFactura="sale.document.includes('Factura')"
                                            :id="sale.id"
                                            :modulo="'Sales'"
                                        /> -->
                    <!-- <button
                                            v-if="sale.state===1" 
                                            v-tooltip.top-center="'Imprimir venta'"
                                            class="btn btn-primary"><i class="icon-fa icon-fa-print"/></button> -->
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <ul class="pagination pagination-primary m-b-0">
          <li class="page-item" v-if="pagination.current_page > 1">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(pagination.current_page - 1)"
              ><i class="icon-fa icon-fa-angle-left"></i
            ></a>
          </li>
          <li
            class="page-item"
            v-for="page in pagesNumber"
            :key="page"
            :class="[page == isActived ? 'active' : '']"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(page)"
              v-text="page"
            ></a>
          </li>
          <li
            class="page-item"
            v-if="pagination.current_page < pagination.last_page"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(pagination.current_page + 1)"
              ><i class="icon-fa icon-fa-angle-right"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
    <sweet-modal ref="confirm_avoid" icon="info">
      <h6>¿Desea anular la venta?</h6>
      <button
        slot="button"
        type="button"
        class="btn btn-info"
        @click="tabModalCancel()"
      >
        No
      </button>
      <button
        slot="button"
        type="button"
        class="btn btn-success ladda-button"
        data-style="expand-right"
        @click="tabModalYes()"
      >
        Si
      </button>
    </sweet-modal>
  </div>
</template>
<script>
import gql from "graphql-tag";
import ladda from "ladda";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import { xelacode } from "../../../helpers/xelacode";
import GenericHeader from "../utils/GenericHeader";
import Print from "../pdf/Print";
export default {
  props: {
    message: {
      type: String,
    },
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }
      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      var to = from + this.offset * 2;
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },
  },
  components: {
    SweetModal,
    SweetModalTab,
    "generic-header": GenericHeader,
    print: Print,
  },
  data() {
    return {
      sales: [],
      allFilter: {
        filter: "",
        critery: "document.name",
        state: 0,
        place: 0,
      },
      user: {},
      idSale: 0,
      status: [
        {
          label: "Pendiente",
          value: 2,
        },
        {
          label: "Comprobado",
          value: 1,
        },
        {
          label: "Anulado",
          value: 0,
        },
      ],
      typeFields: [
        {
          label: "Documento",
          value: "documents.name",
        },
        {
          label: "Vendedor",
          value: "persons.name",
        },
        {
          label: "Cliente",
          value: "sales.nameReference",
        },
      ],
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0,
      },
      offset: 3,
    };
  },
  methods: {
    changePage(page, search, critery) {
      let me = this;
      me.pagination.current_page = page;
      me.getSales(page);
    },
    getSales(page) {
      let vm = this;
      axios
        .get(
          `/api/sale/index?page=${page}&filter=${vm.allFilter.filter}&critery=${vm.allFilter.critery}&status=${vm.allFilter.state}&place=${vm.allFilter.place}`
        )
        .then((response) => {
          vm.sales = response.data.sales.data;
          vm.pagination = response.data.pagination;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openModal(Sale) {
      this.idSale = Sale;
      this.$refs.confirm_avoid.open();
    },
    tabModalCancel() {
      this.$refs.confirm_avoid.close();
    },
    tabModalYes() {
      this.voidInvoice();
    },
    showMessage() {
      if (typeof this.$props.message !== "undefined") {
        toastr.success(this.$props.message, "Listo");
      }
    },
    convertDate(date) {
      var newDate = date.split("-");
      return newDate[2] + "/" + newDate[1] + "/" + newDate[0];
    },
    getUser() {
      let me = this;
      axios
        .get("/api/sale/getUser")
        .then((response) => {
          me.user = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    voidInvoice() {
      let vm = this;
      var l = ladda.create(document.querySelector(".ladda-button"));
      l.start();
      axios
        .post("/api/sale/voidInvoice", {
          id: vm.idSale,
          idUser: vm.user.id,
        })
        .then((response) => {
          toastr.success(response.data.message, "Listo");
          l.stop();
          vm.tabModalCancel();
        })
        .catch((error) => {
          console.log(error);
          l.stop();
          vm.tabModalCancel();
        });
    },
    changeFilter(filter, critery, state, locate) {
      this.allFilter = {
        filter: filter,
        critery: critery,
        state: state,
        place: locate,
      };
      this.getSales(1);
    },
    mymoney(value) {
      return xelacode.money(parseFloat(value));
    },
  },
  mounted() {
    this.showMessage();
    this.getUser();
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/sale/ListSale.vue